import React from "react";
import { Paper } from "@material-ui/core";
import { useEffect } from "react";
import { useState, useRef } from "react";
import { baseUrl } from "../../../services/config";
import { Checkbox, Divider } from "antd";
import { Spinner, Table } from "react-bootstrap";
import StudentStrengthExport from "./StudentStrengthExport";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
const pageStyle = `
  @page {
      margin-left: 0.5in;
    size: A4 portrate !important;
}
`;
const StudentStrength = () => {
  let authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);
  // const loginAccount = JSON.parse(localStorage.getItem("userDetails")).role[0];
  const onBeforeGetContentResolve = React.useRef(null);
  const [printloading, setprintloading] = React.useState(false);
  const [yearId, setYearId] = useState("");
  const [text, setText] = React.useState("old boring text");
  const [sessionData, setSessionData] = useState([]);
  const [fullSession, setFullSession] = useState({});
  const [campusData, setCampusData] = useState(user.campuses || []);
  const [campusId, setCampusId] = useState("");
  const [loading, setLoading] = useState(false);
  const [selected, setselected] = useState("Simple");
  const [reportData, setReportData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [summary, setSummary] = useState(false);
  const [grandRetrain, setGrandRetrain] = useState(0);
  const [grandLeft, setGrandLeft] = useState(0);
  const [campusName, setCampusName] = useState("");
  const [grandSummary, setGrandSummary] = useState(0);
  const [grandMale, setGrandMale] = useState(0);
  const [grandFemale, setGrandFemale] = useState(0);
  const [grandStrength, setGrandStrength] = useState(0);
  const componentRef = useRef(null);

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  const alert = useAlert();

  useEffect(() => {
    getSettingData();
    sessions();
    // getAllCampus();
  }, []);

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setYearId(session.id);
            setFullSession(session);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllCampus = async () => {
    await fetch(`${baseUrl}/campus`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCampusData(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onRadioChanged = (e) => {
    setselected(e.target.value);
  };
  const showResults = () => {
    setLoading(true);
    const data = {
      year_id: yearId,
      campus_ids: campusId ? [parseInt(campusId)] : [],
      summary: summary ? 1 : 0,
    };

    fetch(`${baseUrl}/student-strength-report`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.payload) {
          setLoading(false);
          if (summary) {
            getGrandRetrain(data.payload);
            getGrandleft(data.payload);
            getGrandStrenght(data.payload);
            setSummaryData(data.payload);
          } else {
            let sum = 0;
            let sum2 = 0;
            let sum3 = 0;
            data.payload.forEach((item) => {
              item.Courses.forEach((subitem) => {
                subitem.Classes.forEach((element) => {
                  element.Sections.map((subelement) => {
                    sum += parseInt(subelement?.report?.male);
                  });
                });
              });
            });
            data.payload.forEach((item) => {
              item.Courses.forEach((subitem) => {
                subitem.Classes.forEach((element) => {
                  element.Sections.map((subelement) => {
                    sum2 += parseInt(subelement?.report?.female);
                  });
                });
              });
            });
            data.payload.forEach((item) => {
              item.Courses.forEach((subitem) => {
                subitem.Classes.forEach((element) => {
                  element.Sections.map((subelement) => {
                    sum3 += parseInt(subelement?.report?.strength);
                  });
                });
              });
            });
            setGrandMale(sum);
            setGrandFemale(sum2);
            setGrandStrength(sum3);
            setReportData(data.payload);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getRetrainTotal = (data) => {
    let sum = 0;
    data.Courses.forEach((item) => {
      item.Classes.forEach((subitem) => {
        subitem.Sections.map((element) => {
          sum += parseInt(element?.Report?.retain);
        });
      });
    });
    return sum;
  };

  const getLeftTotal = (data) => {
    let sum = 0;
    data.Courses.forEach((item) => {
      item.Classes.forEach((subitem) => {
        subitem.Sections.map((element) => {
          sum += parseInt(element?.Report?.left_students);
        });
      });
    });
    return sum;
  };

  const getSummaryStrengthTotal = (data) => {
    let sum = 0;
    data.Courses.forEach((item) => {
      item.Classes.forEach((subitem) => {
        subitem.Sections.map((element) => {
          sum += parseInt(element?.Report?.strength);
        });
      });
    });
    return sum;
  };

  const getGrandRetrain = (data) => {
    let sum = 0;
    data.map((subdata) => {
      subdata.Courses.forEach((item) => {
        item.Classes.forEach((subitem) => {
          subitem.Sections.map((element) => {
            sum += parseInt(element?.Report?.retain);
          });
        });
      });
    });
    setGrandRetrain(sum);
  };

  const getGrandleft = (data) => {
    let sum = 0;
    data.map((subdata) => {
      subdata.Courses.forEach((item) => {
        item.Classes.forEach((subitem) => {
          subitem.Sections.map((element) => {
            sum += parseInt(element?.Report?.left_students);
          });
        });
      });
    });
    setGrandLeft(sum);
  };

  const getGrandStrenght = (data) => {
    let sum = 0;
    data.map((subdata) => {
      subdata.Courses.forEach((item) => {
        item.Classes.forEach((subitem) => {
          subitem.Sections.map((element) => {
            sum += parseInt(element?.Report?.strength);
          });
        });
      });
    });
    setGrandSummary(sum);
  };

  const getMaleSum = (data) => {
    let sum = 0;
    data.Courses.forEach((item) => {
      item.Classes.forEach((subitem) => {
        subitem.Sections.map((element) => {
          sum += parseInt(element?.report?.male);
        });
      });
    });
    return sum;
  };

  const getfeMaleSum = (data) => {
    let sum = 0;
    data.Courses.forEach((item) => {
      item.Classes.forEach((subitem) => {
        subitem.Sections.map((element) => {
          sum += parseInt(element?.report?.female);
        });
      });
    });
    return sum;
  };

  const getStrengthSum = (data) => {
    let sum = 0;
    data.Courses.forEach((item) => {
      item.Classes.forEach((subitem) => {
        subitem.Sections.map((element) => {
          sum += parseInt(element?.report?.strength);
        });
      });
    });
    return sum;
  };

  //for print
  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {}, []);

  return (
    <>
      <Paper
        style={{
          marginTop: "10px",
          marginBottom: "10px",
          padding: "15px",
        }}
      >
        <div className="row">
          <div className="col-md-4">
            <label>
              <b>Select Session</b>
            </label>
            <div className="d-flex flex-column ">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => setYearId(e.target.value)}
              >
                <option value="">Select Session</option>
                {sessionData &&
                  sessionData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.year}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="col-md-4">
            <label>
              <b>Select Campus</b>
            </label>
            <div className="d-flex flex-column">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                aria-label="Default select example"
                onChange={(e) => setCampusId(e.target.value)}
              >
                <option value=""> Select Campus</option>
                {campusData &&
                  campusData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="col-md-2 mt-12 d-flex">
            <label className="checkbox checkbox-single">
              <input
                checked={summary}
                onChange={(e) => setSummary(e.target.checked)}
                placeholder="Checkbox"
                type="checkbox"
              />
              <span />
            </label>
            <span className="mt-1 ml-3">Show Summary</span>
          </div>

          <div className="col-md-6">
            <button
              disabled={loading}
              className="btn btn-primary mt-9"
              onClick={showResults}
            >
              Show
            </button>
            {reportData?.length > 0 ? (
              <ReactToPrint
                documentTitle={`Student Strength  Report`}
                onAfterPrint={handleAfterPrint}
                pageStyle={pageStyle}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    disabled={printloading ? true : false}
                    className="btn btn-success button_blue mt-9"
                    style={{ marginLeft: "5px" }}
                  >
                    {printloading ? <span>Printing..</span> : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />
            ) : null}

            <StudentStrengthExport
              summary={summary}
              summaryData={summaryData}
              getRetrainTotal={getRetrainTotal}
              getLeftTotal={getLeftTotal}
              getSummaryStrengthTotal={getSummaryStrengthTotal}
              grandSummary={grandSummary}
              grandLeft={grandLeft}
              grandRetrain={grandRetrain}
              reportData={reportData}
              grandStrength={grandStrength}
              grandFemale={grandFemale}
              grandMale={grandMale}
              getStrengthSum={getStrengthSum}
              getfeMaleSum={getfeMaleSum}
              getMaleSum={getMaleSum}
            />
          </div>
        </div>
        <Divider />
        {loading ? (
          <div className="row justify-content-center">
            <Spinner
              className="text-center"
              variant="info"
              animation="border"
            />
          </div>
        ) : (
          <div id="tableboot mt-5">
            {summary ? (
              <Table responsive>
                <thead>
                  <tr id="tbl">
                    <th className="text-center">Class Name</th>
                    <th className="text-center">Section Name</th>
                    <th className="text-center">Retain</th>
                    <th className="text-center">Left</th>
                    <th className="text-center">Strength</th>
                  </tr>
                </thead>
                <tbody>
                  {summaryData.length > 0 ? (
                    <React.Fragment>
                      {summaryData.map((item, index) => (
                        <React.Fragment key={index}>
                          {getStrengthSum(item) > 0 ? (
                            <tr id="tbl">
                              <td
                                style={{
                                  fontSize: "1.3rem",
                                }}
                                className="text_align_start text-primary"
                              >
                                {item.Campus}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                }}
                                className=""
                              ></td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                }}
                                className="text-center text-primary"
                              >
                                {getRetrainTotal(item)}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                }}
                                className="text-center text-primary"
                              >
                                {getLeftTotal(item)}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                }}
                                className="text-center text-primary"
                              >
                                {getSummaryStrengthTotal(item)}
                              </td>
                            </tr>
                          ) : null}
                          {item?.Courses?.map((subitem, subindex) =>
                            subitem?.Classes?.map((element, subsubindex) => (
                              <React.Fragment key={subsubindex}>
                                {element?.Sections?.map((subelement, indu) => (
                                  <React.Fragment key={indu}>
                                    <tr id="tbl">
                                      <td
                                        style={{
                                          color: "black",
                                        }}
                                        className="text-center"
                                      >
                                        {subitem.Course} &nbsp; (
                                        {element?.Class})
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.Section?.name}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.Report?.retain}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.Report?.left_students}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.Report?.strength}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ))}
                                {element?.Sections.length > 0 && (
                                  <tr id="tbl">
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text_align_start"
                                    ></td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text-end"
                                    >
                                      Class Wise Totals:-
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) => a + parseInt(c.Report.retain),
                                        0
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) =>
                                          a + parseInt(c.Report.left_students),
                                        0
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) =>
                                          a + parseInt(c.Report.strength),
                                        0
                                      )}
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))
                          )}
                        </React.Fragment>
                      ))}
                      <tr id="tbl">
                        <td
                          style={{
                            color: "black",
                            fontWeight: "bold",
                          }}
                          className="text_align_start"
                        ></td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                          }}
                          className="text-end text-primary"
                        >
                          Grand Total:-
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                          }}
                          className="text-center text-primary"
                        >
                          {grandRetrain}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                          }}
                          className="text-center text-primary"
                        >
                          {grandLeft}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                          }}
                          className="text-center text-primary"
                        >
                          {grandSummary}
                        </td>
                      </tr>
                    </React.Fragment>
                  ) : null}
                </tbody>
              </Table>
            ) : (
              <Table responsive>
                <thead>
                  <tr id="tbl">
                    <th className="text-center">Class Name</th>
                    <th className="text-center">Section Name</th>
                    <th className="text-center">Male</th>
                    <th className="text-center">Female</th>
                    <th className="text-center">Strength</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.length > 0 ? (
                    <React.Fragment>
                      {reportData.map((item, index) => (
                        <React.Fragment key={index}>
                          {getStrengthSum(item) > 0 ? (
                            <tr id="tbl">
                              <td
                                style={{
                                  fontSize: "1.3rem",
                                }}
                                className="text_align_start text-primary"
                              >
                                {item.Campus}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                }}
                                className=""
                              ></td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                }}
                                className="text-center text-primary"
                              >
                                {getMaleSum(item)}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                }}
                                className="text-center text-primary"
                              >
                                {getfeMaleSum(item)}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                }}
                                className="text-center text-primary"
                              >
                                {getStrengthSum(item)}
                              </td>
                            </tr>
                          ) : null}
                          {item?.Courses?.map((subitem, subindex) =>
                            subitem?.Classes?.map((element, subsubindex) => (
                              <React.Fragment key={subsubindex}>
                                {element?.Sections?.map((subelement, indu) => (
                                  <React.Fragment key={indu}>
                                    <tr id="tbl">
                                      <td
                                        style={{
                                          color: "black",
                                        }}
                                        className="text-center"
                                      >
                                        {subitem.Course} &nbsp; (
                                        {element?.Class})
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.Section?.name}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.report?.male}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.report?.female}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.report?.strength}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ))}
                                {element?.Sections.length > 0 && (
                                  <tr id="tbl">
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text_align_start"
                                    ></td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text-end"
                                    >
                                      Class Wise Totals:-
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) => a + parseInt(c.report.male),
                                        0
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) => a + parseInt(c.report.female),
                                        0
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) =>
                                          a + parseInt(c.report.strength),
                                        0
                                      )}
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))
                          )}
                        </React.Fragment>
                      ))}
                      <tr id="tbl">
                        <td
                          style={{
                            color: "black",
                            fontWeight: "bold",
                          }}
                          className="text_align_start"
                        ></td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                          }}
                          className="text-end text-primary"
                        >
                          Grand Total:-
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                          }}
                          className="text-center text-primary"
                        >
                          {grandMale}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                          }}
                          className="text-center text-primary"
                        >
                          {grandFemale}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                          }}
                          className="text-center text-primary"
                        >
                          {grandStrength}
                        </td>
                      </tr>
                    </React.Fragment>
                  ) : null}
                </tbody>
              </Table>
            )}
          </div>
        )}
        {/* ///for print */}
        {/* print start here */}

        <div
          ref={componentRef}
          id="printSection"
          className="customTablePrint"
        >
          <div className="p-3" style={{ display: "flex" }}>
            <img
              // className='col-md-2'
              style={{ height: 110, width: 110 }}
              src={icon}
            />
            <div className="col-md-8">
              <h1>{unitName}</h1>
              <h2>
                STUDENT STRENGTH LIST FOR THE ACADEMIC SESSION{" "}
                {fullSession.year}{" "}
              </h2>
              <h3>
                <b>{campusName}</b>
              </h3>
            </div>
          </div>
          {summary ? (
            <div>
              <Table
                responsive
                style={{
                  fontSize: "20px",
                  whiteSpace: "normal",
                  padding: "1px",
                }}
              >
                <thead>
                  <tr
                    id="tbl"
                    style={{
                      whiteSpace: "normal",
                      padding: "1px",
                    }}
                  >
                    <th
                      className="text-center"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Class Name
                    </th>
                    <th
                      className="text-start"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Section Name
                    </th>
                    <th
                      className="text-center"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Retain
                    </th>
                    <th
                      className="text-center"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Left
                    </th>
                    <th
                      className="text-center"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Strength
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {summaryData.length > 0 ? (
                    <React.Fragment>
                      {summaryData.map((item, index) => (
                        <React.Fragment key={index}>
                          {getStrengthSum(item) > 0 ? (
                            <tr
                              id="tbl"
                              style={{
                                whiteSpace: "normal",
                                padding: "1px",
                                borderTop: "1px solid black",
                                borderBottom: "1px solid black",
                              }}
                            >
                              <td
                                style={{
                                  fontSize: "20",

                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                                className="text_align_start text-primary"
                              >
                                <b> {item.Campus}</b>
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                                className=""
                              ></td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                                className="text-center text-primary"
                              >
                                {getRetrainTotal(item)}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                                className="text-center text-primary"
                              >
                                {getLeftTotal(item)}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                                className="text-center text-primary"
                              >
                                {getSummaryStrengthTotal(item)}
                              </td>
                            </tr>
                          ) : null}

                          {item?.Courses?.map((subitem, subindex) =>
                            subitem?.Classes?.map((element, subsubindex) => (
                              <React.Fragment key={subsubindex}>
                                {element?.Sections?.map((subelement, indu) => (
                                  <React.Fragment key={indu}>
                                    <tr
                                      id="tbl"
                                      style={{
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                    >
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          padding: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {subitem.Course} &nbsp; (
                                        {element?.Class})
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          padding: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.Section?.name}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          padding: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.Report?.retain}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          padding: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.Report?.left_students}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          padding: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.Report?.strength}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ))}
                                {element?.Sections.length > 0 && (
                                  <tr
                                    id="tbl"
                                    style={{
                                      whiteSpace: "normal",
                                      padding: "1px",
                                      borderTop: "1px solid black",
                                      borderBottom: "1px solid black",
                                    }}
                                  >
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                      className="text_align_start"
                                    ></td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                      className="text-end"
                                    >
                                      Class Wise Totals:-
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) => a + parseInt(c.Report.retain),
                                        0
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) =>
                                          a + parseInt(c.Report.left_students),
                                        0
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) =>
                                          a + parseInt(c.Report.strength),
                                        0
                                      )}
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))
                          )}
                        </React.Fragment>
                      ))}
                      <tr
                        id="tbl"
                        style={{
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                      >
                        <td
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="text_align_start"
                        ></td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "25px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="text-end text-primary"
                        >
                          Grand Total:-
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "25px",
                            whiteSpace: "normal",
                            padding: "1px",
                            // fontSize: "2.0rem",
                          }}
                          className="text-center text-primary"
                        >
                          {grandRetrain}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "25px",
                            whiteSpace: "normal",
                            padding: "1px",
                            // fontSize: "2.0rem",
                          }}
                          className="text-center text-primary"
                        >
                          {grandLeft}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "25px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="text-center text-primary"
                        >
                          {grandSummary}
                        </td>
                      </tr>
                    </React.Fragment>
                  ) : null}
                </tbody>
              </Table>
            </div>
          ) : (
            <div>
              <Table
                responsive
                style={{
                  fontSize: "20px",
                  whiteSpace: "normal",
                  padding: "1px",
                }}
              >
                <thead>
                  <tr
                    id="tbl"
                    style={{
                      whiteSpace: "normal",
                      padding: "1px",
                    }}
                  >
                    <th
                      className="text-center"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Class Name
                    </th>
                    <th
                      className="text-start"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Section Name
                    </th>
                    <th
                      className="text-center"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Male
                    </th>
                    <th
                      className="text-center"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Female
                    </th>
                    <th
                      className="text-center"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Strength
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.length > 0 ? (
                    <React.Fragment>
                      {reportData.map((item, index) => (
                        <React.Fragment key={index}>
                          {getStrengthSum(item) > 0 ? (
                            <tr
                              id="tbl"
                              style={{
                                whiteSpace: "normal",
                                padding: "1px",
                                borderTop: "1px solid black",
                                borderBottom: "1px solid black",
                              }}
                            >
                              <td
                                style={{
                                  fontSize: "20",

                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                                className="text_align_start text-primary"
                              >
                                <b> {item.Campus}</b>
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                                className=""
                              ></td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                                className="text-center text-primary"
                              >
                                {getMaleSum(item)}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                                className="text-center text-primary"
                              >
                                {getfeMaleSum(item)}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                                className="text-center text-primary"
                              >
                                {getStrengthSum(item)}
                              </td>
                            </tr>
                          ) : null}

                          {item?.Courses?.map((subitem, subindex) =>
                            subitem?.Classes?.map((element, subsubindex) => (
                              <React.Fragment key={subsubindex}>
                                {element?.Sections?.map((subelement, indu) => (
                                  <React.Fragment key={indu}>
                                    <tr
                                      id="tbl"
                                      style={{
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                    >
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          padding: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {subitem.Course} &nbsp; (
                                        {element?.Class})
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          padding: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.Section?.name}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          padding: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.report?.male}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          padding: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.report?.female}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          padding: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {subelement?.report?.strength}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ))}
                                {element?.Sections.length > 0 && (
                                  <tr
                                    id="tbl"
                                    style={{
                                      whiteSpace: "normal",
                                      padding: "1px",
                                      borderTop: "1px solid black",
                                      borderBottom: "1px solid black",
                                    }}
                                  >
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                      className="text_align_start"
                                    ></td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                      className="text-end"
                                    >
                                      Class Wise Totals:-
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) => a + parseInt(c.report.male),
                                        0
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) => a + parseInt(c.report.female),
                                        0
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        whiteSpace: "normal",
                                        padding: "1px",
                                      }}
                                      className="text-center"
                                    >
                                      {element.Sections.reduce(
                                        (a, c) =>
                                          a + parseInt(c.report.strength),
                                        0
                                      )}
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))
                          )}
                        </React.Fragment>
                      ))}
                      <tr
                        id="tbl"
                        style={{
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                      >
                        <td
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="text_align_start"
                        ></td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "25px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="text-end text-primary"
                        >
                          Grand Total:-
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "25px",
                            whiteSpace: "normal",
                            padding: "1px",
                            // fontSize: "2.0rem",
                          }}
                          className="text-center text-primary"
                        >
                          {grandMale}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "25px",
                            whiteSpace: "normal",
                            padding: "1px",
                            // fontSize: "2.0rem",
                          }}
                          className="text-center text-primary"
                        >
                          {grandFemale}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: "25px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="text-center text-primary"
                        >
                          {grandStrength}
                        </td>
                      </tr>
                    </React.Fragment>
                  ) : null}
                </tbody>
              </Table>
            </div>
          )}
        </div>
        {/* print end here */}
      </Paper>
    </>
  );
};

export default StudentStrength;
